export default {
  namespaced: true,
  actions: {
    update({ commit }, householdIncome) {
      return Vue.$http.patch(`/admin/household_incomes/${householdIncome.id}`, { householdIncome })
    },
  },
}
